<script>
	import {createEventDispatcher, onMount} from 'svelte';
	import {replace} from 'svelte-spa-router';
	import PainelBox from '../templates/PainelBox.svelte';
	import GradeCartoes from '../../componentes/GradeCartoes.svelte';
	import CartaoRetangulo from '../../componentes/cartoes/CartaoRetangulo.svelte';
	import {
		API,
		cabecalhoPadraoRequisicao,
		codificarPayloadURL,
		StatusHttp,
		TextoFeedback,
		TipoEvento,
		verificarSessionStorage
	} from '../../utils';

	const dispatch = createEventDispatcher();
	let parseDistribuicoes = [];

	onMount(async () => {
		if (verificarSessionStorage('AVAL_TOKEN'))
			carregarDistribuicoesAtribuidas(1);
		else 
			replace("/login");
	});

	const carregarDistribuicoesAtribuidas = async (pagina) => {
		parseDistribuicoes = [];

		dispatch('routeEvent', {
			tipo: TipoEvento.ESTA_CARREGANDO,
			valor: true,
			mensagem: 'Carregando distribuições ...',
		});

		const resposta = await fetch(API('distribuicoes-atribuidas'), {
			method: 'GET',
			headers: cabecalhoPadraoRequisicao()
		}).catch(erros => {
			dispatch('routeEvent', {
				tipo: TipoEvento.ABRIR_MODAL,
				titulo: 'Erro',
				conteudo: TextoFeedback.ERRO_REQUISICAO
			});

			replace("/login");
		});
		
		const { dados } = await resposta.json();

		if (resposta.status == StatusHttp.OK) {
			Object.values(dados).forEach( objeto => {

				if (objeto.objetoDistribuidoEProjeto == true) {
					parseDistribuicoes.push({
						link: '#',
						titulo: `Projeto: ${objeto.objetoDistribuido.titulo}`,
						descricao: `
							<hr>
							Área de atuação: <strong class="has-text-info">${objeto.objetoDistribuido.alocacao}</strong>
							<br> 
							Modalidade: <strong class="has-text-info">${objeto.objetoDistribuido.modalidade}</strong>`,
						acoes: [{
							url: `#/distribuicao/confirmacao-aceite-ou-recusa-avaliacao/${objeto.objetoDistribuido.codigo}/${objeto.id}?p=${codificarPayloadURL(`tp=${objeto.objetoDistribuido.titulo}&ap=${objeto.objetoDistribuido.alocacao}&op=ACEITE`)}`,
							texto: 'Aceitar'
						}, {
							url: `#/distribuicao/confirmacao-aceite-ou-recusa-avaliacao/${objeto.objetoDistribuido.codigo}/${objeto.id}?p=${codificarPayloadURL(`tp=${objeto.objetoDistribuido.titulo}&ap=${objeto.objetoDistribuido.alocacao}&op=RECUSA`)}`,
							texto: 'Recusar'
						}]
					});
				} else {
					parseDistribuicoes.push({
						link: '#',
						titulo: `Apresentação semana de graduação - Inscrição ${objeto.objetoDistribuido.id_zerofill}/${objeto.objetoDistribuido.projeto.codigo}`,
						descricao: `
							<hr>
							Área de atuação: <strong class="has-text-info">${objeto.objetoDistribuido.projeto.alocacao}</strong>
							<br> 
							Modalidade: <strong class="has-text-info">${objeto.objetoDistribuido.projeto.modalidade}</strong>`,
						acoes: [{
							url: `#/distribuicao/confirmacao-aceite-ou-recusa-avaliacao/${objeto.objetoDistribuido.projeto.codigo}/${objeto.id}?p=${codificarPayloadURL(`tp=${objeto.objetoDistribuido.projeto.titulo}&ap=${objeto.objetoDistribuido.projeto.alocacao}&op=ACEITE`)}`,
							texto: 'Aceitar'
						}, {
							url: `#/distribuicao/confirmacao-aceite-ou-recusa-avaliacao/${objeto.objetoDistribuido.projeto.codigo}/${objeto.id}?p=${codificarPayloadURL(`tp=${objeto.objetoDistribuido.projeto.titulo}&ap=${objeto.objetoDistribuido.projeto.alocacao}&op=RECUSA`)}`,
							texto: 'Recusar'
						}]
					});
				}

			});

			parseDistribuicoes = [...parseDistribuicoes];
		} else if (resposta.status == StatusHttp.HTTP_NOT_FOUND) {
			dispatch('routeEvent', {
				tipo: TipoEvento.ABRIR_MODAL,
				titulo: 'Aviso',
				conteudo: 'Nenhuma distribuição encontrada para sua conta. Para ver os projetos ACEITOS, acesse a opção AVALIAÇÕES.'
			});
			
			replace("/painel");
		} else if (resposta.status == StatusHttp.UNAUTHORIZED) {
			dispatch('routeEvent', {
				tipo: TipoEvento.ABRIR_MODAL,
				titulo: 'Erro',
				conteudo: 'Usuário sem autorização pra acessar recurso.'
			});
			
			replace("/login");
		} else {
			dispatch('routeEvent', {
				tipo: TipoEvento.ABRIR_MODAL,
				titulo: 'Erro',
				conteudo: 'Erro desconhecido. Se persistir, favor entrar em contato pelo suporte.'
			});
			
			replace("/login");
		}

		dispatch('routeEvent', { 
			tipo: TipoEvento.ESTA_CARREGANDO,
			valor: false
		});
	}
</script>

<PainelBox 
	largura="12" 
	deslocamento="0"
	titulo="Projetos distribuídos para a sua conta">
		
	<div class="columns mt-5">
		<div class="column">
			<p class="has-text-danger">Ao clicar em "aceitar" você terá acesso completo ao projeto/apresentação e automaticamente passará a ser o(a) avaliador(a) do mesmo, devendo responder o formulário de avaliação atenciosamente. Ao recusar o projeto/apresentação, o mesmo será devolvido ao sistema para posterior distribuição para outro(a) avaliador(a).</p>
		</div>
	</div>

	<GradeCartoes itens={parseDistribuicoes} componente={CartaoRetangulo} flexWrap={false} parametros={{descricaoHtml: true}} />
</PainelBox>
